import React from 'react';
import { useReveal, JoinBlock, InstagramSection, PageHeader, Pillars } from '../components/shared';
import { IMAGES, JOURNEY, PILLARS } from '../mock';

export default function About({ go }) {
  useReveal([]);
  return (
    <div className="page active">
      <PageHeader eyebrow="Surf Coast Victoria" title="Discover South Beach Blooms" sub="Torquay Flower Farm" />

      <div className="split about-hero">
        <div className="split-photo bg-photo" style={{ backgroundImage: `url(/brand/about.webp)` }} />
        <div className="split-copy">
          <span className="eyebrow rev">Meet Laura &amp; Matt</span>
          <h2 className="rev" style={{ fontFamily: "'Jost',sans-serif", fontWeight: 800, fontSize: 40, color: 'var(--ink)', lineHeight: 1.05, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 20 }}>From Backyard<br /><em style={{ fontStyle: 'italic', fontWeight: 300, fontSize: '0.82em' }}>to Farm Gate</em></h2>
          <p className="body-text rev">Everything begins on a windswept paddock behind the dunes at Torquay — the same stretch of coast where we surf before work, swim after it, and spend most weekends chasing sun. Loving this place enough to live by its rhythms is what got the farm started in the first place. Here, we're growing chemical-free cut flowers built for salt air and sandy soil — and building a small farm gate and workshops around the first season's harvest.</p>
          <p className="body-text rev">For a long time we dreamed of "what could be," and had the vision to see if we could turn a paddock into a vibrant micro flower farm growing dreamy dahlias on the Surf Coast. We wanted to prove you don't need hundreds of acres to share beautiful flowers with your community and neighbours — just deep care, an obsession for quality, and a willingness to get your hands dirty.</p>
          <p className="body-text rev">Our hope is that our community can simply push the pram or take a morning walk across the road to our farm gate and fill their day with a little colour and joy. Or if you're just passing through on your way down the coast, stop by the farm gate, grab some blooms and keep on driving. Welcome to Torquay Flower Farm — we're so glad you're here.</p>
          <p className="rev" style={{ fontFamily: "'Alex Brush',cursive", fontSize: 30, color: 'var(--rose)', marginTop: 6, lineHeight: 1 }}>Laura &amp; Matt x</p>
          <div className="rev" style={{ marginTop: 24 }}><button className="btn btn-rose" onClick={() => go('tubers', { scrollToJoin: true })}>Join Our Community</button></div>
        </div>
      </div>

      <Pillars />

      <div className="journey-wrap">
        <span className="eyebrow rev" style={{ textAlign: 'center', display: 'block' }}>From Tuber to Bloom</span>
        <h2 className="rev" style={{ textAlign: 'center', fontFamily: "'Jost',sans-serif", fontWeight: 800, fontSize: 36, color: 'var(--ink)', textTransform: 'uppercase', letterSpacing: 1 }}>Our Journey.</h2>
        <div className="journey-list">
          {JOURNEY.map((j, i) => (
            <div className="journey-item rev" key={i}>
              <div className="journey-date">{j.date}</div>
              <div className="journey-text">{j.text}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="pillars-section">
        <span className="eyebrow rev">Our Approach</span>
        <h2 className="rev" style={{ fontFamily: "'Jost',sans-serif", fontWeight: 800, fontSize: 38, color: 'var(--ink)', textTransform: 'uppercase', letterSpacing: 1 }}>How We Grow.</h2>
        <div className="pillars-grid">
          {PILLARS.map((p, i) => (
            <div className="pillar" key={i}>
              <span className="pillar-n">{p.n}</span>
              <div className="pillar-t">{p.t}</div>
              <p className="pillar-d">{p.d}</p>
            </div>
          ))}
        </div>
      </div>

      <JoinBlock eyebrow="Inaugural Dahlia Sale · September 2027" headline="We sell to our community first." body="First access to tubers. Farm stand updates. Growing tips. Behind the scenes. All of it — to our community, before anyone else." />
      <InstagramSection />
    </div>
  );
}
